import { lowerFirst as lowerFirst$1 } from "../../string/lowerFirst.mjs";
import { toString } from "../util/toString.mjs";
//#region src/compat/string/lowerFirst.ts
/**
* Converts the first character of string to lower case.
*
* @param {string} str - The string that is to be changed
* @returns {string} - The converted string.
*
* @example
* const convertedStr1 = lowerCase('fred') // returns 'fred'
* const convertedStr2 = lowerCase('Fred') // returns 'fred'
* const convertedStr3 = lowerCase('FRED') // returns 'fRED'
*/
function lowerFirst(str) {
	return lowerFirst$1(toString(str));
}
//#endregion
export { lowerFirst };
